var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M29.036 18.5c.373 0 .747.146 1.032.436.288.294.432.68.432 1.065 0 .385-.144.771-.431 1.064h0l-7.668 7.759c-.39.395-.82.612-1.235.645-.4.031-.78-.113-1.067-.405h0l-4.167-4.246a1.515 1.515 0 01-.432-1.064c0-.386.144-.771.432-1.065a1.442 1.442 0 012.065 0h0l3.161 3.22 6.845-6.973c.285-.29.659-.436 1.033-.436z", stroke: "currentColor", strokeWidth: 1, fill: "none", fillRule: "evenodd" })));
});
